import { render, staticRenderFns } from "./PickupInfoModal.vue?vue&type=template&id=0ad970ec&scoped=true&lang=pug&"
import script from "./PickupInfoModal.vue?vue&type=script&lang=js&"
export * from "./PickupInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad970ec",
  null
  
)

export default component.exports